export default "__VITE_ASSET__CjVLsK$p__"